import React from 'react';
import { history } from '../store';

export default class Header extends React.Component {

  onSignout = () => {
    sessionStorage.setItem("isAuthenticated", false);
    this.props.signOut();
  }
  onClickLogo = () => {
    window.location = 'https://www.natwestmarkets.com/';
  }

  constructor(props) {
    super(props)
    this.state = {
        loadLogo: false
      };
  }

  componentWillMount(){
    let loadLogo = this.getParameterByName();
    this.setState({ loadLogo:  loadLogo})
  }

  getParameterByName = () => {
    let url = window.location.href;
    return (url.indexOf("nwm") !== -1);
  }

  render() {
    let cssForXsScreen = this.state.loadLogo ? "col-xs-3" : "col-xs-2";
    return (
      <div className="banner bannerHeader">
        <div className="container">
          <div className="navbar-header">
          
            <div className={"navbar-brand col-md-4 col-sm-4 " + cssForXsScreen}>
            {this.state.loadLogo ?
              <div className="navbar-brand-cursor" onClick={this.onClickLogo}>
              <a><i className="logo-natwest"></i></a>
              <span></span>
              </div>: null}
            </div>
            <div className="col-md-4 col-sm-4 col-xs-8 navbar-title-wrap">
             <h4 className="navbar-header-title" onClick={()=>{history.push('./')}}>RealisedRate.com</h4>
            </div>
            <div className="col-md-4 col-sm-4 col-xs-3">
            </div>
          </div>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Header.js